import { REDUX_MODEL_KEY } from '../../../../constants'
import { getValueReduxUtil } from '../../../../utils/get-value'
import { REDUX_LOCAL_KEY_PREFIX } from '../../../../constants/local-key'
import { isEqualUtil } from 'packages/src'

export function getUpdatesWithoutDuplicatesReduxReducerUtil (instance, updates) {
  if (!instance[REDUX_MODEL_KEY.DATA]) {
    return updates
  }

  return Object
    .keys(updates)
    .reduce((obj, key) => {
      if (
        !isEqualUtil(getValueReduxUtil(instance, key), updates[key]) ||
        key.startsWith(REDUX_LOCAL_KEY_PREFIX)
      ) {
        obj[key] = updates[key]
      }
      return obj
    }, {})
}
